<template>
  <div class="countdown">
    <div class="countdown-inner" v-if="dateInMilliseconds - now > 0">
      <div class="block">
        <p class="digit">{{ days | two_digits }}</p>
        <p class="text">Días</p>
      </div>
      <div class="block">
        <p class="digit">{{ hours | two_digits }}</p>
        <p class="text">Horas</p>
      </div>
      <div class="block">
        <p class="digit">{{ minutes | two_digits }}</p>
        <p class="text">Minutos</p>
      </div>
      <div class="block">
        <p class="digit">{{ seconds | two_digits }}</p>
        <p class="text">Segundos</p>
      </div>
    </div>
    <div class="countdown-inner" v-if="dateInMilliseconds - now <= 0">
      <p>AHORA</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  mounted() {
    window.setInterval(() => {
      this.now = Math.trunc(new Date() / 1000);
    }, 1000);
  },
  props: {
    date: {
      type: String
    }
  },
  data() {
    return {
      now: Math.trunc(new Date() / 1000)
    };
  },
  computed: {
    dateInMilliseconds() {
      const date = this.date.split(/[^0-9]/);
      return Math.trunc(
        new Date(
          date[0],
          date[1] - 1,
          date[2],
          date[3],
          date[4],
          date[5]
        ).valueOf() / 1000
      );
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
    },
    hours() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
    },
    days() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
    }
  },
  filters: {
    two_digits: function(value) {
      if (value < 0) {
        return "00";
      }
      if (value.toString().length <= 1) {
        return `0${value}`;
      }
      return value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.countdown-inner {
  display: flex;
  justify-content: center;
}

.block {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
}

.text {
  color: $black;
  font-size: 1.3rem;
  font-weight: 600;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
}

.digit {
  color: $white;
  font-size: 3rem;
  font-weight: 300;
  margin: 0 0.5rem;
  text-align: center;
}
@media (max-width: prev-viewport-max-size("md")) {
  .text {
    font-size: 1rem;
  }

  .digit {
    font-size: 2rem;
  }
}
</style>